import React, { useMemo } from "react";
import {
  ObjectRankingParameterTypeTitles,
  ObjectRankingParameterTypeCssClasses
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";


const getValue = (type) => {
  if (type) {
    if (type === "Grade" || type === "1") return 1;
    if (type === "FatherJob" || type === "2") return 2;
    if (type === "SupportingInstitue" || type === "3") return 3;
    if (type === "SpecialCondition" || type === "4") return 4;
    if (type === "Distance" || type === "5") return 5;
    if (type === "MartyrOrVeterans" || type === "6") return 6;
    if (type === "Other" || type === "7") return 7;
    if (type === "MilitaryService" || type === "8") return 8;
    if (type === "ChildsCount" || type === "9") return 9;
  } else return 0;
};


const setRow = (row) => {
  
  return (
    < span
      className={`label label-lg label-light-${ObjectRankingParameterTypeCssClasses[getValue(row.rpType)]} label-inline`
      }
    >
      <FormattedMessage id={ObjectRankingParameterTypeTitles[getValue(row.rpType)]} />
    </span >
  )
}

export const RankingParameterColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index}</div>)
}